import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  deleteMealApi,
  getMemberDetailApi,
  transferMealApi,
  updateMedicalCertificateApi,
  updateParentalConsentApi,
  updateTagApi,
  updateTshirtSizeApi,
} from '../../api/member.api';
import {
  getMemberDetailErrorAct,
  getMemberDetailSuccessAct,
  updateMedCertSuccessAct,
  updateMedCertErrorAct,
  updateParentalConsentSuccessAct,
  updateParentalConsentErrorAct,
  updateTshirtSizeSuccessAct,
  updateTshirtSizeErrorAct,
  updateTagStateSuccessAct,
  updateTagStateErrorAct,
  removeMealSuccessAct,
  removeMealErrorAct,
  transferMealSuccessAct,
  transferMealErrorAct,
} from './actions';
import {
  GET_MEMBER_DETAIL,
  REMOVE_MEAL,
  TRANSFER_MEAL,
  UPDATE_MEDICAL_CERT,
  UPDATE_PARENTAL_CONSENT,
  UPDATE_TAG_STATE,
  UPDATE_TSHIRT_SIZE,
} from './constants';
import { getErrorMessage } from '../../utils/error.util';

function* fetchMemberDetail({ payload }) {
  try {
    const { data } = yield call(getMemberDetailApi, payload);
    if (data) {
      yield put(getMemberDetailSuccessAct(data));
    } else {
      yield put(getMemberDetailErrorAct({ message: 'Something went wrong' }));
    }
  } catch (error) {
    const { response } = error;
    let errMessage = 'Something went wrong';
    if (response && response.data) {
      errMessage = response.data.message;
    }
    yield put(getMemberDetailErrorAct(errMessage));
  }
}

function* updateMedCertificateState({ payload }) {
  try {
    const { data } = yield call(updateMedicalCertificateApi, payload);
    if (data) {
      yield put(updateMedCertSuccessAct(data));
    } else {
      throw new Error('Something went wrong');
    }
  } catch (error) {
    const errMessage = getErrorMessage(error);
    yield put(
      updateMedCertErrorAct({ error: errMessage, oldValue: payload.oldValue }),
    );
  }
}

function* updateParentalConsentState({ payload }) {
  try {
    const { data } = yield call(updateParentalConsentApi, payload);
    if (data) {
      yield put(updateParentalConsentSuccessAct(data));
    } else {
      throw new Error('Something went wrong');
    }
  } catch (error) {
    const errMessage = getErrorMessage(error);
    yield put(
      updateParentalConsentErrorAct({
        error: errMessage,
        oldValue: payload.oldValue,
      }),
    );
  }
}

function* updateTshirtSize({ payload }) {
  try {
    const { data } = yield call(updateTshirtSizeApi, payload);
    if (data) {
      yield put(updateTshirtSizeSuccessAct(data));
    } else {
      // yield put(
      //   updateTshirtSizeErrorAct({
      //     error: 'Something went wrong',
      //     oldValue: payload.oldValue,
      //   }),
      // );
      throw new Error('Something went wrong');
    }
  } catch (error) {
    const errMessage = getErrorMessage(error);
    yield put(
      updateTshirtSizeErrorAct({
        error: errMessage,
        oldValue: payload.oldValue,
      }),
    );
  }
}

function* updateTagState({ payload }) {
  const { data: payloadData } = payload;
  try {
    const { data } = yield call(updateTagApi, payload);
    if (data) {
      yield put(updateTagStateSuccessAct(data));
    } else {
      yield put(
        updateTagStateErrorAct({
          tagId: payloadData.tagId,
          active: !payloadData.active,
          error: 'Something went wrong',
        }),
      );
    }
  } catch (error) {
    const { response } = error;
    let errMessage = 'Something went wrong';
    if (response && response.data) {
      errMessage = response.data.message;
    }
    yield put(
      updateTagStateErrorAct({
        tagId: payloadData.tagId,
        active: !payloadData.active,
        error: errMessage,
      }),
    );
  }
}

function* transferMeal({ payload }) {
  try {
    const { data } = yield call(transferMealApi, payload);
    if (data) {
      yield put(transferMealSuccessAct(data));
    } else {
      yield put(
        transferMealErrorAct({
          error: 'Something went wrong',
        }),
      );
    }
  } catch (error) {
    const { response } = error;
    let errMessage = 'Something went wrong';
    if (response && response.data) {
      errMessage = response.data.message;
    }
    yield put(
      transferMealErrorAct({
        error: errMessage,
      }),
    );
  }
}

function* deleteMeal({ payload }) {
  const { id } = payload;
  try {
    const { data } = yield call(deleteMealApi, id);
    if (data) {
      yield put(removeMealSuccessAct());
    } else {
      yield put(
        removeMealErrorAct({
          error: 'Something went wrong',
        }),
      );
    }
  } catch (error) {
    const { response } = error;
    let errMessage = 'Something went wrong';
    if (response && response.data) {
      errMessage = response.data.message;
    }
    yield put(
      removeMealErrorAct({
        error: errMessage,
      }),
    );
  }
}

// Individual exports for testing
export default function* memberDetailSaga() {
  //  uncomment this to setp default action
  yield takeLatest(GET_MEMBER_DETAIL, fetchMemberDetail);
  yield takeLatest(UPDATE_MEDICAL_CERT, updateMedCertificateState);
  yield takeLatest(UPDATE_PARENTAL_CONSENT, updateParentalConsentState);
  yield takeLatest(UPDATE_TSHIRT_SIZE, updateTshirtSize);
  yield takeEvery(UPDATE_TAG_STATE, updateTagState);
  yield takeLatest(TRANSFER_MEAL, transferMeal);
  yield takeLatest(REMOVE_MEAL, deleteMeal);
}
